import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "fileSize",
    standalone: false
})
export class FileSizePipe implements PipeTransform {
    private units = ["k", "MB"];
    public transform(value: number, decimalPlaces: number = 0, targetUnit: "k" | "MB" = "k"): string {
        const divisor = Math.pow(1024, this.units.indexOf(targetUnit) + 1);
        return (value / divisor).toFixed(decimalPlaces) + targetUnit;
    }
}
